<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>A Propos</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">Hub4B FrontOffice est un produit de la société AVMUp</p>

            <p class="text">Version : {{ version }}</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="close()" style="visibility: hidden">Cancel</button>
        <button mat-raised-button class="accent-button" (click)="close()">Ok</button>
    </mat-card-actions>
</mat-card>
